// extracted by mini-css-extract-plugin
export default {"customers":"mT","wrapper":"nT","carousel":"oT","carousel_inner_wrapper":"pT","top_quote":"qT","bottom_quote":"rT","carousel_wrapper":"sT","feedbacks_wrapper":"tT","arrows":"uT","prev":"vT","img":"wT","review_btn":"xT"};
    if(module.hot) {
      // 1713809679206
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  